const list = {
    SUPER: ["super-admin", "admin", "md"],
    ADMIN: [
        "admin",
        "tech-support",
        "operation-admin",
        "general-manager",
        "md",
        "it-support-hq",
        "deputy-general-manager",
        "assistant-general-manager",
        "operation-manager",
        "finance-manager",
        // "finance-supervisor",
        "warehouse-manager",
        "accountant"
    ],
    REGION_MANAGER: "region-manager",
    IT_SUPPORT_REGION: "it-support-region"
};

export const highest_role_under_post_officer = {
    "qanda.create": 19
};

export const rank_enum = {
    luxuary_rank: 30,
    no_current_branch_role: 60,
    editable_role_level: 30
};

export const no_branch_roles = [
    "admin",
    "general-manager",
    "md",
    "deputy-general-manager",
    // 'operation-manager',
    "accountant",
    "corporate-manager",
    "marketing-manager",
    "hr-manager",
    "hr-admin",
    "hr-assistant",
    "me-manager",
    "tech-support",
    "operation-admin",
    "it-support-hq",
    "assistant-general-manager",
    "finance-manager",
    'assistant-manager-finance',
    "finance-supervisor",
    "accountant-cooperate",
    "accountant-online",
    "accountant-cash-book",
    "customer-service",
    "call-center",

    "approve_request_id",
    "approved",
    "ban_request_id",
    "ban_confirm"
];

export default {
    list,
    highest_role_under_post_officer,
    rank_enum,
    no_branch_roles
};
